var miniworldHouseGeometry = new(function() {
	// point definitions
	this.topLeft = { x: 150, y: 150 };
	this.topRight = { x: 800, y: 150 };
	this.bottomLeft = { x: 150, y: 400 };
	this.bottomRight = { x: 800, y: 400 };
	this.cornerTopLeft = { x: 0, y: 92 };
	this.cornerTopRight = { x: 950, y: 92 };
	this.cornerBottomLeft = { x: 0, y: 458 };
	this.cornerBottomRight = { x: 950, y: 458 };
	this.frameTopLeft = { x: 0, y: 0 };
	this.frameTopRight = { x: 950, y: 0 };
	this.frameBottomLeft = { x: 0, y: 550 };
	this.frameBottomRight = { x: 950, y: 550 };
	this.placementBarrierLeft = {
		x: this.cornerBottomLeft.x + .85 * (this.bottomLeft.x - this.cornerBottomLeft.x),
		y: this.cornerBottomLeft.y + .85 * (this.bottomLeft.y - this.cornerBottomLeft.y)
	};
	this.placementBarrierRight = {
		x: this.cornerBottomRight.x + .85 * (this.bottomRight.x - this.cornerBottomRight.x),
		y: this.cornerBottomRight.y + .85 * (this.bottomRight.y - this.cornerBottomRight.y)
	};

	// polygon definitions			     
	this.leftWall = [this.cornerTopLeft, this.topLeft, this.bottomLeft, this.cornerBottomLeft];
	this.rightWall = [this.cornerTopRight, this.topRight, this.bottomRight, this.cornerBottomRight];
	this.ceiling = [this.frameTopRight, this.cornerTopRight, this.topRight, this.topLeft, this.cornerTopLeft, this.frameTopLeft];
	this.floor = [this.frameBottomLeft, this.cornerBottomLeft, this.bottomLeft, this.bottomRight, this.cornerBottomRight, this.frameBottomRight];
	this.backWall = [this.topLeft, this.topRight, this.bottomRight, this.bottomLeft];

	this.wallPolygon = {
		"left": this.leftWall,
		"right": this.rightWall,
		"ceiling": this.ceiling,
		"floor": this.floor,
		"back": this.backWall
	};
	this.wallUpperLeft = {
		"left": this.cornerTopLeft,
		"right": { x: 800, y: 92 },
		"ceiling": this.frameTopLeft,
		"floor": { x: 0, y: 400 },
		"back": this.topLeft
	};

	// other sizes
	this.iconMaxSideLength = 75;

	this.levelFactor = function(level) {
		// All items shrink when the house level increases
		// All item sizes should be multiplied by this
		// Magic formula copied from old flash code
		return Math.pow(0.92, level);
	};

	// Functions for calculating perspective
	this.scalingFactor = function(posY) {
		// Scaling factor for items placed on the floor
		// Derived from the fact that items should always fill the same percentage of
		// the horizontal space of the room.
		return 3 / 377 * posY - 823 / 377;
	};

	this.mapWallPosition = function(posX, posY) {
		// Coordinates of wall items point to the mid of the lower edge of an image as if the left and right wall were
		// in the same plane as the back wall
		// This function transform coordinates from this fictional plane to pixel positions on the canvas.
		// Visible x in range [-100, 1050]
		// (y for wall items should always be in range [150, 400])
		if (posX < this.topLeft.x) {
			// Use vertical line of symmetry
			var mirroredPosition = this.mapWallPosition(950 - posX, posY);
			return { x: 950 - mirroredPosition.x, y: mirroredPosition.y };
		} else if (posX <= this.topRight.x) {
			// Points on the back wall don't need to be transformed
			return { x: posX, y: posY };
		} else {
			// Magical formula derived from intersecting multiple lines
			var newX = 800 - (18750 * (-800 + posX)) / (-92125 + 58 * posX);

			var wallUpperY = 150 + (this.cornerTopRight.y - 150) / 150 * (newX - 800);
			var wallHeight = (this.bottomRight.y - this.topRight.y) + (this.cornerBottomRight.y - this.cornerTopRight.y - this.bottomRight.y + this.topRight.y) / 150 * (newX - 800);

			var newY = wallUpperY + wallHeight * (posY - 150) / 250;

			return { x: newX, y: newY };
		}
	};

	this.reverseMapWallPosition = function(posX, posY) {
		// Map screen position to coordinates on the wall
		// Ignores ceiling and floor
		if (posX < this.topLeft.x) {
			var mirroredPosition = this.reverseMapWallPosition(950 - posX, posY);
			return { x: 950 - mirroredPosition.x, y: mirroredPosition.y };
		} else if (posX <= this.topRight.x) {
			return { x: posX, y: posY };
		} else {
			var orgX = (125 * (-469600 + 737 * posX)) / (2 * (-13825 + 29 * posX));

			var wallUpperY = 150 + (this.cornerTopRight.y - 150) / 150 * (posX - 800);
			var wallHeight = (this.bottomRight.y - this.topRight.y) + (this.cornerBottomRight.y - this.cornerTopRight.y - this.bottomRight.y + this.topRight.y) / 150 * (posX - 800);

			var orgY = this.topLeft.y + (posY - wallUpperY) / wallHeight * 250;

			return { x: orgX, y: orgY };
		}
	};

	this.isPointOnFloor = function(posX, posY) {
		var polygon = [this.placementBarrierLeft, this.placementBarrierRight, this.cornerBottomRight, this.frameBottomRight, this.frameBottomLeft, this.cornerBottomLeft];
		var point = { x: posX, y: posY };
		return this.polygonCheck(point, polygon);
	};

	// Algorithm for checking whether a point lies inside a polygon
	// Taken from https://github.com/substack/point-in-polygon/blob/master/index.js
	// and modified to fit our point structure.
	// Originally published under the MIT License: http://opensource.org/licenses/mit-license.html
	this.polygonCheck = function(point, vs) {
		// ray-casting algorithm based on
		// http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html

		var x = point.x,
			y = point.y;

		var inside = false;
		for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
			var xi = vs[i].x,
				yi = vs[i].y;
			var xj = vs[j].x,
				yj = vs[j].y;

			var intersect = ((yi > y) != (yj > y))
				&& (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
			if (intersect) inside = !inside;
		}

		return inside;
	};
});
